import * as React from 'react';
import RcSwitch from 'rc-switch';
import classNames from 'classnames';
import omit from 'omit.js';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import Wave from '../_util/wave';
import { ConfigContext } from '../config-provider';
import SizeContext from '../config-provider/SizeContext';
import devWarning from '../_util/devWarning';
const Switch = React.forwardRef((props, ref) => {
    if (process.env.NODE_ENV !== 'production')
        devWarning('checked' in props || !('value' in props), 'Switch', '`value` is not a valid prop, do you mean `checked`?');
    const { prefixCls: customizePrefixCls, size: customizeSize, loading, className = '', disabled, } = props;
    const { getPrefixCls, direction } = React.useContext(ConfigContext);
    const size = React.useContext(SizeContext);
    const prefixCls = getPrefixCls('switch', customizePrefixCls);
    const loadingIcon = (<div className={`${prefixCls}-handle`}>
      {loading && <LoadingOutlined className={`${prefixCls}-loading-icon`}/>}
    </div>);
    const classes = classNames(className, {
        [`${prefixCls}-small`]: (customizeSize || size) === 'small',
        [`${prefixCls}-loading`]: loading,
        [`${prefixCls}-rtl`]: direction === 'rtl',
    });
    return (<Wave insertExtraNode>
      <RcSwitch {...omit(props, ['loading'])} prefixCls={prefixCls} className={classes} disabled={disabled || loading} ref={ref} loadingIcon={loadingIcon}/>
    </Wave>);
});
Switch.__ANT_SWITCH = true;
export default Switch;
